import React, { useState } from "react";
import StarRating from "./StarRating";
import "./ProductReviews.css";

const ProductReviews = ({ reviews, loading, submitting, onSubmit }) => {
    const [name, setName] = useState("");
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (rating < 1) {
            setError("Please add a star rating.");
            return;
        }
        setError("");
        await onSubmit({ name: name.trim() || "Anonymous", rating, comment: comment.trim() });
        setName("");
        setRating(0);
        setComment("");
    };

    return (
        <div className="product-reviews">
            <h3>Customer Reviews</h3>

            <form className="product-reviews-form" onSubmit={handleSubmit}>
                <div className="product-reviews-form-row">
                    <input
                        type="text"
                        placeholder="Your name (optional)"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        maxLength={60}
                    />
                    <div className="product-reviews-star-picker">
                        <StarRating rating={rating} onChange={setRating} />
                    </div>
                </div>
                <textarea
                    placeholder="Share your experience... (optional)"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    maxLength={500}
                    rows={3}
                />
                {error && <p className="product-reviews-error">{error}</p>}
                <button type="submit" disabled={submitting}>
                    {submitting ? "Submitting..." : "Submit Review"}
                </button>
            </form>

            <div className="product-reviews-list">
                {loading && <p>Loading reviews...</p>}
                {!loading && reviews.length === 0 && <p>No reviews yet. Be the first!</p>}
                {reviews.map((review) => (
                    <div key={review.id} className="product-review-item">
                        <div className="product-review-header">
                            <StarRating rating={review.rating} />
                            <span className="product-review-name">{review.name || "Anonymous"}</span>
                        </div>
                        {review.comment && <p className="product-review-comment">{review.comment}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductReviews;
